/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/modules/ed-pot-upsell-widget.js":
/*!************************************************!*\
  !*** ./src/js/modules/ed-pot-upsell-widget.js ***!
  \************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var PotUpsellWidget = /*#__PURE__*/function (_HTMLElement) {
  _inherits(PotUpsellWidget, _HTMLElement);
  var _super = _createSuper(PotUpsellWidget);
  function PotUpsellWidget() {
    _classCallCheck(this, PotUpsellWidget);
    return _super.apply(this, arguments);
  }
  _createClass(PotUpsellWidget, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this.checkButtonVisibility();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.potUpsellItems = this.querySelector('.pot-upsell-items');
      this.prevArrow = this.querySelector('.nav-arrow.prev-arrow');
      this.nextArrow = this.querySelector('.nav-arrow.next-arrow');
      this.potUpsellItem = this.potUpsellItems.querySelector('.pot-upsell-item');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      if (this.potUpsellItems && this.prevArrow && this.nextArrow) {
        this.prevArrow.addEventListener('click', function (e) {
          return _this.onNavArrowClick(e);
        });
        this.nextArrow.addEventListener('click', function (e) {
          return _this.onNavArrowClick(e);
        });
        this.potUpsellItems.addEventListener('scroll', function () {
          _this.checkButtonVisibility();
        });
      }
    }
  }, {
    key: "checkButtonVisibility",
    value: function checkButtonVisibility() {
      var container = this.potUpsellItems;
      var leftButton = this.prevArrow;
      var rightButton = this.nextArrow;
      var tolerance = 10; // Adjust as needed

      if (container.scrollLeft <= tolerance) {
        leftButton.style.visibility = 'hidden';
      } else {
        leftButton.style.visibility = 'visible';
      }
      if (container.scrollLeft + container.clientWidth + tolerance >= container.scrollWidth) {
        rightButton.style.visibility = 'hidden';
      } else {
        rightButton.style.visibility = 'visible';
      }
    }
  }, {
    key: "onNavArrowClick",
    value: function onNavArrowClick(e) {
      var arrow = e.currentTarget;
      var direction = arrow.classList.contains('prev-arrow') ? -1 : 1;
      var itemWidth = this.potUpsellItem.offsetWidth + parseInt(window.getComputedStyle(this.potUpsellItem).marginRight) + 10;
      this.potUpsellItems.scrollBy({
        left: direction * itemWidth,
        behavior: 'smooth'
      });
    }
  }]);
  return PotUpsellWidget;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-pot-upsell-widget', PotUpsellWidget);
var PotUpsellItem = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(PotUpsellItem, _HTMLElement2);
  var _super2 = _createSuper(PotUpsellItem);
  function PotUpsellItem() {
    _classCallCheck(this, PotUpsellItem);
    return _super2.apply(this, arguments);
  }
  _createClass(PotUpsellItem, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.infoIcon = this.querySelector('[data-info-icon]');
      this.radioButton = this.querySelector('[data-pot-upsell-radio-btn] input');
      this.items = document.querySelectorAll('[data-upsell-item]');
      this.popup = this.querySelector('[data-pot-info-popup]');
      this.popupClose = this.popup.querySelector('[data-popup-close]');
      this.popupButton = this.popup.querySelector('[data-popup-select-button]');
      this.variantSelectors = this.querySelectorAll('.variant-color-selector input');
      this.imageElement = this.querySelector('.image-container img');
      this.priceContainer = this.querySelector('.price-container');
      this.colorSelector = this.querySelector('[data-variant-color-selector]');
      this.selectorTitle = this.querySelector('[data-selector-title]');
      this.colorSelectors = document.querySelectorAll('[data-variant-color-selector]');
      this.upsellWidget = document.querySelector('ed-pot-upsell-widget');
      this.colorOptions = this.querySelectorAll('.pot-color-option');
      this.mainProductPrice = parseFloat(this.dataset.mainProductPrice) || 0;
      this.mainProductComparePrice = parseFloat(this.dataset.mainProductComparePrice) || 0;
      this.currentVariantPrice = parseFloat(this.dataset.firstVariantPrice) || 0;
      this.currentVariantCompareAtPrice = parseFloat(this.dataset.firstVariantCompareAtPrice) || 0;
      this.mainProductWeight = parseFloat(this.dataset.mainProductWeight) || 0;
      this.mainProductRequiresShipping = this.dataset.mainProductRequiresShipping !== 'false';
      this.currentVariantWeight = parseFloat(this.dataset.firstVariantWeight) || 0;
      this.currentVariantRequiresShipping = this.dataset.firstVariantRequiresShipping !== 'false';
      this.refreshMainPriceElements();
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this2 = this;
      this.infoIcon.addEventListener('click', this.onInfoIconClick.bind(this));
      this.addEventListener('click', function (e) {
        return _this2.onUpsellItemClick(e);
      });
      if (this.popupClose) {
        this.popupClose.addEventListener('click', this.onPopupClose.bind(this));
      }
      if (this.popupButton) {
        this.popupButton.addEventListener('click', this.onPopupButtonClick.bind(this));
      }
      if (this.popup) {
        this.popup.addEventListener('click', function (e) {
          if (e.target === _this2.popup) {
            _this2.onPopupClose();
          }
        });
      }
      if (this.variantSelectors) {
        this.variantSelectors.forEach(function (selector) {
          selector.addEventListener('change', _this2.onVariantChange.bind(_this2));
        });
      }
      if (this.colorOptions) {
        this.colorOptions.forEach(function (span) {
          span.addEventListener('click', _this2.onColorOptionClick.bind(_this2));
        });
      }
      if (this.colorSelector) {
        this.upsellWidget.append(this.colorSelector);
      }
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          var variant = event && event.data && event.data.variant;
          if (!variant) return;
          var shippingNotice = document.querySelector('sc-product-shipping-notice');
          var shippingVariant = shippingNotice && typeof shippingNotice.getVariant === 'function' ? shippingNotice.getVariant(variant) : null;
          _this2.mainProductPrice = parseFloat(variant.price) || 0;
          _this2.mainProductComparePrice = parseFloat(variant.compare_at_price) || 0;
          _this2.mainProductWeight = parseFloat(shippingVariant && shippingVariant.weight || variant.weight || variant.grams) || 0;
          _this2.mainProductRequiresShipping = shippingVariant ? shippingVariant.requiresShipping !== false : variant.requires_shipping !== false && variant.requiresShipping !== false;
          _this2.refreshMainPriceElements();
          if (_this2.radioButton.checked) {
            _this2.updatePrice();
          }
        });
      }
    }
  }, {
    key: "onColorOptionClick",
    value: function onColorOptionClick(e) {
      var span = e.currentTarget;
      var inputWrapper = span.closest('.input-wrapper');
      if (inputWrapper) {
        var input = inputWrapper.querySelector('input[type="radio"]');
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
      }
    }
  }, {
    key: "onVariantChange",
    value: function onVariantChange(e) {
      var input = e.target;
      var variantId = input.getAttribute('data-variant-id');
      var variantPrice = parseFloat(input.getAttribute('data-price')) || 0;
      var variantCompareAtPrice = parseFloat(input.getAttribute('data-compare-at-price')) || 0;
      var variantWeight = parseFloat(input.getAttribute('data-weight')) || 0;
      var variantRequiresShipping = input.getAttribute('data-requires-shipping') !== 'false';
      var variantImage = input.getAttribute('data-image');
      var variantTitle = input.getAttribute('data-variant-title');

      // Update image
      if (variantImage) {
        this.imageElement.src = variantImage;
      }

      // Update title
      if (variantTitle) {
        this.selectorTitle.innerText = variantTitle;
      }

      // Update price display in the upsell item
      this.priceContainer.innerHTML = '';
      if (variantCompareAtPrice > variantPrice) {
        this.priceContainer.innerHTML += "<div class=\"compare-price\"><s>".concat(this.formatMoney(variantCompareAtPrice), "</s></div>");
      }
      this.priceContainer.innerHTML += "<div class=\"price\">".concat(this.formatMoney(variantPrice), "</div>");

      // Update the hidden radio button's data-variant-id
      this.radioButton.setAttribute('data-variant-id', variantId);
      this.radioButton.setAttribute('id', "pot-upsell-radio".concat(variantId));
      var label = this.radioButton.nextElementSibling;
      if (label) {
        label.setAttribute('for', "pot-upsell-radio".concat(variantId));
      }

      // Update the current variant's price
      this.currentVariantPrice = variantPrice;
      this.currentVariantCompareAtPrice = variantCompareAtPrice;
      this.currentVariantWeight = variantWeight;
      this.currentVariantRequiresShipping = variantRequiresShipping;

      // Update the total price if the item is selected
      if (this.radioButton.checked) {
        this.updatePrice();
      }
    }
  }, {
    key: "onUpsellItemClick",
    value: function onUpsellItemClick(e) {
      // Prevent triggering variant change when clicking on variant selector
      if (e.target.closest('.variant-color-selector')) {
        return;
      }
      this.radioButton.checked = !this.radioButton.checked;
      this.items.forEach(function (item) {
        return item.classList.remove('selected');
      });
      this.colorSelectors.forEach(function (selector) {
        return selector.classList.add('hidden');
      });
      if (this.radioButton.checked) {
        this.classList.add('selected');
        if (this.colorSelector) {
          this.colorSelector.classList.remove('hidden');
        }
      } else {
        this.classList.remove('selected');
        if (this.colorSelector) {
          this.colorSelector.classList.add('hidden');
        }
      }
      this.updatePrice();
    }
  }, {
    key: "selectItem",
    value: function selectItem() {
      // uncheck all other radio buttons
      this.items.forEach(function (item) {
        var radio = item.querySelector('[data-pot-upsell-radio-btn] input');
        if (radio) {
          radio.checked = false;
        }
        item.classList.remove('selected');
      });

      // check this radio button and add 'selected' class
      this.radioButton.checked = true;
      this.classList.add('selected');
    }
  }, {
    key: "refreshMainPriceElements",
    value: function refreshMainPriceElements() {
      this.priceElement = document.querySelector('.price__container .price__regular');
      this.comparePriceElement = document.querySelector('.price__container .price-item--sale');
      this.saleBadgeElement = document.querySelector('.sc-price__badge-sale');
    }
  }, {
    key: "updateSaleBadge",
    value: function updateSaleBadge(totalPrice, totalComparePrice) {
      if (!this.saleBadgeElement || !totalComparePrice || totalComparePrice <= totalPrice) return;
      var discountPercentage = Math.round((totalComparePrice - totalPrice) * 100 / totalComparePrice);
      var discountTemplate = this.saleBadgeElement.getAttribute('data-discount-template') || '';
      if (discountTemplate) {
        this.saleBadgeElement.innerText = discountTemplate.replace('[discount]', discountPercentage);
      }
    }
  }, {
    key: "updatePrice",
    value: function updatePrice() {
      this.refreshMainPriceElements();
      var totalPrice = this.mainProductPrice;
      var totalComparePrice = this.mainProductComparePrice;
      if (this.radioButton.checked) {
        totalPrice += this.currentVariantPrice;
        totalComparePrice += this.currentVariantCompareAtPrice > this.currentVariantPrice ? this.currentVariantCompareAtPrice : this.currentVariantPrice;
      }
      var totalWeight = this.mainProductWeight + (this.radioButton.checked ? this.currentVariantWeight : 0);
      var totalRequiresShipping = this.mainProductRequiresShipping || this.radioButton.checked && this.currentVariantRequiresShipping;

      // Update the price elements
      if (this.mainProductComparePrice > this.mainProductPrice) {
        // Display sale price
        if (this.comparePriceElement) {
          this.comparePriceElement.innerText = this.formatMoney(totalPrice);
        }
        this.updateSaleBadge(totalPrice, totalComparePrice);
      } else {
        // Display regular price
        if (this.priceElement) {
          this.priceElement.innerText = this.formatMoney(totalPrice);
        }
      }
      document.dispatchEvent(new CustomEvent('sc:shipping-notice:update', {
        detail: {
          price: totalPrice,
          weight: totalWeight,
          requiresShipping: totalRequiresShipping
        }
      }));
    }
  }, {
    key: "onInfoIconClick",
    value: function onInfoIconClick(e) {
      e.stopPropagation();
      document.body.appendChild(this.popup);
      document.body.classList.add('overflow-hidden');
      this.popup.classList.remove('hidden');
    }
  }, {
    key: "onPopupButtonClick",
    value: function onPopupButtonClick(e) {
      e.preventDefault();
      this.selectItem();
      this.onPopupClose();
    }
  }, {
    key: "onPopupClose",
    value: function onPopupClose() {
      this.popup.classList.add('hidden');
      document.body.classList.remove('overflow-hidden');
    }
  }, {
    key: "formatMoney",
    value: function formatMoney(amount) {
      var num = parseInt(amount, 10) / 100;
      var formatted = num.toFixed(2);
      formatted = formatted.replace('.', ',');
      return '€' + formatted;
    }
  }]);
  return PotUpsellItem;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-pot-upsell-item', PotUpsellItem);

/***/ }),

/***/ "./src/js/modules/ed-progress-bar.js":
/*!*******************************************!*\
  !*** ./src/js/modules/ed-progress-bar.js ***!
  \*******************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdCartProgressBar = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdCartProgressBar, _HTMLElement);
  var _super = _createSuper(EdCartProgressBar);
  function EdCartProgressBar() {
    _classCallCheck(this, EdCartProgressBar);
    return _super.apply(this, arguments);
  }
  _createClass(EdCartProgressBar, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this.cartTotal = this.getAttribute('cart-total');
      this.shippingPalletThreshold = this.getAttribute('shipping-pallet-threshold');
      this.shippingPalletPrice = this.getAttribute('shipping-pallet-price');
      this.updatePalletShipping();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.progressBarContainer = this.querySelector('.progress-bar-container');
      this.progressBarMessage = this.querySelector('.progress-bar-message:not([data-pallet-shipping-message])');
      this.palletShippingMessage = this.querySelector('[data-pallet-shipping-message]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('updateProgressBar', this.onUpdateProgressbar.bind(this));
    }
  }, {
    key: "onUpdateProgressbar",
    value: function onUpdateProgressbar(e) {
      this.cartTotal = e.detail.totalPrice;
      this.updatePalletShipping();
    }
  }, {
    key: "updatePalletShipping",
    value: function updatePalletShipping() {
      var cartTotal = parseInt(this.cartTotal);
      var shippingPalletThreshold = parseInt(this.shippingPalletThreshold);
      if (cartTotal >= shippingPalletThreshold) {
        this.palletShippingMessage.classList.add('active');
        this.progressBarContainer.classList.add('hidden');
        this.progressBarMessage.classList.add('hidden');
      } else {
        this.palletShippingMessage.classList.remove('active');
        this.progressBarContainer.classList.remove('hidden');
        this.progressBarMessage.classList.remove('hidden');
      }
    }
  }]);
  return EdCartProgressBar;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-cart-progress-bar', EdCartProgressBar);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_ed_progress_bar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/ed-progress-bar */ "./src/js/modules/ed-progress-bar.js");
/* harmony import */ var _modules_ed_progress_bar__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_progress_bar__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_ed_pot_upsell_widget__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/ed-pot-upsell-widget */ "./src/js/modules/ed-pot-upsell-widget.js");
/* harmony import */ var _modules_ed_pot_upsell_widget__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_pot_upsell_widget__WEBPACK_IMPORTED_MODULE_1__);
/*
DO NOT TOUCH THIS FILE OUTSIDE OF /src DIRECTORY
this file gets compiled ./assets/custom.js - make sure to import every module here.
*/



var upcartBundleSubscriptionStartedAt = 0;
var upcartBundleSubscriptionTimer = null;
var upcartBundleSubscriptionDelay = 75;
var upcartBundleSubscribed = false;
function isUpcartBundleSelected() {
  return typeof window.scCartExperiment?.scIsNative === 'function' ? !window.scCartExperiment.scIsNative() : window.scCartVariant !== 'native';
}
function stopUpcartBundleSubscriptionRetry() {
  window.clearTimeout(upcartBundleSubscriptionTimer);
  upcartBundleSubscriptionTimer = null;
}
function subscribeToUpcartBundleUpdates(restartTimeout) {
  if (!isUpcartBundleSelected()) {
    stopUpcartBundleSubscriptionRetry();
    return;
  }
  if (upcartBundleSubscribed) {
    var currentCart = typeof window.upcartGetCart === 'function' ? window.upcartGetCart() : null;
    if (currentCart && currentCart.items) onUpCartUpdated(currentCart.items);
    return;
  }
  if (restartTimeout || !upcartBundleSubscriptionStartedAt) {
    upcartBundleSubscriptionStartedAt = Date.now();
    upcartBundleSubscriptionDelay = 75;
  }
  if (typeof window.upcartSubscribeCartLoaded !== 'function' || typeof window.upcartSubscribeCartUpdated !== 'function') {
    if (Date.now() - upcartBundleSubscriptionStartedAt >= 30000 || upcartBundleSubscriptionTimer) return;
    upcartBundleSubscriptionTimer = window.setTimeout(function () {
      upcartBundleSubscriptionTimer = null;
      subscribeToUpcartBundleUpdates(false);
    }, upcartBundleSubscriptionDelay);
    upcartBundleSubscriptionDelay = Math.min(Math.ceil(upcartBundleSubscriptionDelay * 1.5), 1000);
    return;
  }
  upcartBundleSubscribed = true;
  stopUpcartBundleSubscriptionRetry();
  window.upcartSubscribeCartLoaded(function (_ref) {
    var cart = _ref.cart;
    onUpCartUpdated(cart && cart.items || []);
  });
  window.upcartSubscribeCartUpdated(function (_ref2) {
    var cart = _ref2.cart;
    onUpCartUpdated(cart && cart.items || []);
  });
  var currentCart = typeof window.upcartGetCart === 'function' ? window.upcartGetCart() : null;
  if (currentCart && currentCart.items) onUpCartUpdated(currentCart.items);
}
document.addEventListener('DOMContentLoaded', function () {
  subscribeToUpcartBundleUpdates(true);
});
document.addEventListener('sc:cart-variant-ready', function (event) {
  if (event.detail && event.detail.variant === 'upcart') subscribeToUpcartBundleUpdates(true);
});
document.addEventListener('sc:cart-variant-change', function (event) {
  if (event.detail && event.detail.variant === 'native') stopUpcartBundleSubscriptionRetry();
});
function onUpCartUpdated(items) {
  if (!isUpcartBundleSelected()) return;
  items.forEach(function (item) {
    if (!item.properties || !item.properties['_bundle']) return;
    getUpcartRoots().forEach(function (root) {
      var productRow = findUpcartProductRow(root, item);
      if (!productRow) return;
      var stepper = productRow.querySelector([
        '.styles_ProductRow__stepper__',
        '.upcart-internal-component-product-tile__quantity-selector',
        '.upcart-internal-component-product-tile__quantity',
        '[class*="quantity-selector"]',
        '[class*="stepper"]'
      ].join(','));
      if (stepper) {
        stepper.style.display = 'none';
        stepper.setAttribute('data-sc-upcart-bundle-quantity-hidden', 'true');
      }
    });
  });
}
function getUpcartRoots() {
  var host = document.getElementById('upCart');
  var roots = [document];
  if (host && host.shadowRoot) roots.unshift(host.shadowRoot);
  return roots;
}
function findUpcartProductRow(root, item) {
  if (item.key && typeof root.getElementById === 'function') {
    var rowById = root.getElementById(item.key);
    if (rowById) return rowById;
  }
  var productPath = getUpcartProductPath(item.url);
  var rows = Array.from(root.querySelectorAll('.upcart-product-item, .upcart-internal-component-product-tile'));
  if (!productPath) return rows.length === 1 ? rows[0] : null;
  return rows.find(function (row) {
    return Array.from(row.querySelectorAll('a[href]')).some(function (link) {
      return getUpcartProductPath(link.href) === productPath;
    });
  }) || null;
}
function getUpcartProductPath(url) {
  if (!url) return null;
  try {
    return new URL(url, window.location.origin).pathname;
  } catch (error) {
    return null;
  }
}
})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;
